<div class="app-loading-spinner">
  <mat-spinner [diameter]="60"></mat-spinner>
</div>
